import { createFileRoute } from '@tanstack/react-router'
import { requireGuest } from '@/lib/auth-guard'

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: () => requireGuest(),
})
